import {MapTypesToInstances, PatEntry} from "../pattern_match";
import {BaseTree} from "../model";
import {Token} from "../lexer";
import {ScopeChainNode} from "../analysis";
import {HoverResult} from "./hover_result";

export type HoverPattern<
	T extends Readonly<Array<PatEntry>>,
	F extends (
		chain: PatEntry[],
		scope: ScopeChainNode,
		...args: MapTypesToInstances<T>
	) => HoverResult | string | null,
> = {
	pat: T;
	handler: F;
};

export type HoverPatternFrom<T extends Readonly<Array<PatEntry>>> =
	HoverPattern<
		T,
		(
			chain: PatEntry[],
			scope: ScopeChainNode,
			...args: MapTypesToInstances<T>
		) => HoverResult | string | null
	>;

export function makeHoverPattern<
	T extends Readonly<Array<PatEntry>>,
	F extends (
		chain: PatEntry[],
		scope: ScopeChainNode,
		...args: MapTypesToInstances<T>
	) => HoverResult | string | null,
>(pat: T, handler: F): HoverPattern<T, F> {
	return {pat, handler};
}

export function getFirstScopeOfChain(_chain: (BaseTree | Token)[]) {
	for (let i = _chain.length - 1; i >= 0; i--) {
		const entry = _chain[i]!;
		if (entry instanceof BaseTree && entry.scope) {
			return entry.scope;
		}
	}
	return null;
}
